class ToggleVideoTestimonials extends HTMLButtonElement {
  constructor() {
    super();

    this.clickHandler = this.onClick.bind(this);

    this.addEventListener("click", this.clickHandler);
  }

  disconnectCallback() {
    this.removeEventListener("click", this.clickHandler);
  }

  get dialogEl() {
    if (this._dialogEl) {
      return this._dialogEl;
    }

    const controlledId = this.getAttribute("aria-controls");
    if (!controlledId) {
      console.warn("Element does not have aria-controls attribute.");
      return null;
    }

    const dialog = document.querySelector(`dialog#${controlledId}`);
    if (!dialog) {
      console.warn(`No <dialog> element found with id="${controlledId}".`);
    }

    const dialogComponent = dialog.closest("dialog-component");
    if (!dialogComponent) {
      console.warn(`No <dialog-component> element found with id="${controlledId}".`);
    }

    this._dialogEl = dialogComponent;
    return dialogComponent;
  }

  get sliderEl() {
    return (this._sliderEl = this._sliderEl || this.dialogEl.querySelector(".carousel"));
  }

  onClick(event) {
    event.preventDefault();

    const index = Number(this.dataset.index);

    if (!this.dialogEl) {
      return;
    }

    if (this.sliderEl?.swiperInstance) {
      this.sliderEl.goToSlide(index);
    } else {
      this.sliderEl.addEventListener(
        "carousel:ready",
        () => {
          this.sliderEl.goToSlide(index);
        },
        { once: true }
      );
    }

    this.dialogEl.showDialog();
  }
}
customElements.define("toggle-video-testimonials", ToggleVideoTestimonials, { extends: "button" });

/* ── GIF-like 2-second looping thumbnail previews ── */
const VT_GIF_DURATION = 2; // seconds

function initGifThumb(video) {
  if (video._vtGifInit) return;
  video._vtGifInit = true;

  video.muted = true;
  video.loop = false; // we handle looping manually
  video.playsInline = true;

  video.addEventListener("timeupdate", () => {
    if (video.currentTime >= VT_GIF_DURATION) {
      video.currentTime = 0;
      video.play().catch(() => {});
    }
  });

  // Ensure it starts playing (autoplay may be blocked on some browsers)
  video.play().catch(() => {});
}

function initAllGifThumbs(root = document) {
  root.querySelectorAll("video.vt-gif-thumb").forEach(initGifThumb);
}

// Run once DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initAllGifThumbs());
} else {
  initAllGifThumbs();
}

// Also catch thumbnails injected by Swiper / dialog lazy-loading
const vtGifObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches?.("video.vt-gif-thumb")) {
        initGifThumb(node);
      } else {
        node.querySelectorAll?.("video.vt-gif-thumb").forEach(initGifThumb);
      }
    }
  }
});
vtGifObserver.observe(document.body, { childList: true, subtree: true });
